import { render, staticRenderFns } from "./FinalScore.vue?vue&type=template&id=51375c5a&scoped=true&"
import script from "./FinalScore.vue?vue&type=script&lang=ts&"
export * from "./FinalScore.vue?vue&type=script&lang=ts&"
import style0 from "./FinalScore.vue?vue&type=style&index=0&id=51375c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51375c5a",
  null
  
)

export default component.exports